<!-- 首页脚链 -->
<template>
  <div class="foolterLike">
    <ul>
      <li v-for="item in list" :key="item.id" @click="sendopen(item)">
        <span>{{ item.name }}</span> <span>|</span>
      </li>
    </ul>
    <div class="Filing" v-if="!privatization"> 
      <span @click="openhome">wenxiang.cn</span>
      <span
        ><a
          href="https://beian.miit.gov.cn/#/Integrated/index"
          rel="noreferrer"
          target="_blank"
          >{{ host == 'www.51jab.com' || host == '8.141.87.51' ?'备案号:皖ICP备2021017705号-17':'备案号:皖ICP备2021017705号-6'}}</a
        ></span
      >
      <span
        ><a
          href="https://beian.mps.gov.cn/#/query/webSearch"
          rel="noreferrer"
          target="_blank"
          ><img src="@/assets/gawb.jpg" alt="" /> 皖公网安备:34170202000698</a
        ></span
      >
    </div>
  </div>
</template>

<script setup>
import { onBeforeMount, ref } from "vue";
import { getAnkletList } from "@/api/Equipment.js";

// 获取脚链 列表
let pageDate = {
  pageNum: 1,
  pageSize: 10,
};
const list = ref([]);
const privatization = window.g.privatization;
const host = location.host
const Initialize = () => {
  getAnkletList(pageDate).then((res) => {
    if (res.code === 1) {
      list.value = res.data.list;
    }
  });
};

// 跳转脚链
const sendopen = (item) => {
  window.open(item.path);
};
// 跳转文香官网
const openhome = () => {
  window.open("https://wenxiang.cn/");
};

onBeforeMount(() => {
  Initialize();
});
</script>
<style lang="less" scoped>
.foolterLike {
  width: 1440px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 10px;
  ul {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    row-gap: 15px;
    li {
      // padding: 0 20px;
      color: var(--font-icon-placeholder);
      text-align: center;
      /* body/body-Medium-14px */
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px; /* 157.143% */
      cursor: pointer;
      span:first-child {
        transition: 0.3s;
        &:hover {
          color: var(--Brand-Brand7-Normal);
        }
      }
      span:last-child {
        padding: 0 20px;
      }
    }
    li:last-child {
      span:last-child {
        display: none;
      }
    }
  }
  .Filing {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    gap: 20px;
    color: var(--font-icon-placeholder);
    text-align: center;
    /* body/body-Medium-14px */
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
    span:first-child {
      cursor: pointer;
      &:hover {
        color: var(--Brand-Brand7-Normal);
      }
    }
    a {
      padding-left: 25px;
      position: relative;
      font-size: 14px;
      color: var(--font-icon-placeholder);
      line-height: 22px; /* 157.143% */
      transition: 0.3s;
      text-decoration: none;
      img {
        position: absolute;
        left: 0;
        top: 0;
      }
    }
  }
}
</style>
